// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"85a4de31","455":"3c5095ea","977":"8f2a6847"}[chunkId] + ".chunk.js";
};